/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProfileSizesData = {
    /**
     * Shoe size unit of the user.
     */
    shoeSizeUnit: ProfileSizesData.shoeSizeUnit;
    /**
     * Left shoe size of the user.
     */
    leftShoeSize: number;
    /**
     * Right shoe size of the user.
     */
    rightShoeSize: number;
    /**
     * Left shoe width of the user.
     */
    leftShoeWidth: ProfileSizesData.leftShoeWidth;
    /**
     * Right shoe width of the user.
     */
    rightShoeWidth: ProfileSizesData.rightShoeWidth;
    /**
     * Right size preferences of the user.
     */
    rightSizePreferences: ProfileSizesData.rightSizePreferences;
    /**
     * Left size preferences of the user.
     */
    leftSizePreferences: ProfileSizesData.leftSizePreferences;
};
export namespace ProfileSizesData {
    /**
     * Shoe size unit of the user.
     */
    export enum shoeSizeUnit {
        US = 'US',
        UK = 'UK',
        EU = 'EU',
        CM = 'CM',
    }
    /**
     * Left shoe width of the user.
     */
    export enum leftShoeWidth {
        STANDARD = 'standard',
        WIDE = 'wide',
        NARROW = 'narrow',
        X_WIDE = 'x-wide',
    }
    /**
     * Right shoe width of the user.
     */
    export enum rightShoeWidth {
        STANDARD = 'standard',
        WIDE = 'wide',
        NARROW = 'narrow',
        X_WIDE = 'x-wide',
    }
    /**
     * Right size preferences of the user.
     */
    export enum rightSizePreferences {
        WOMENS = 'WOMENS',
        MENS = 'MENS',
    }
    /**
     * Left size preferences of the user.
     */
    export enum leftSizePreferences {
        WOMENS = 'WOMENS',
        MENS = 'MENS',
    }
}

